// Copyright (c) 2018 Deere & Company

import InstructionsPanelsContainer from './instructions-panels-container';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.partReturns.requestDetails
});

export default connect(getStateToBindToContainerProps)(InstructionsPanelsContainer);



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/instructions-panels/index.js